import { Person, PushPin, Settings, Hub, Message } from "@mui/icons-material";
import { Chip } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Drawer, { DrawerProps } from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { useLocation, useNavigate } from "react-router-dom";
import { targetEnv } from "../api";

const categories = [
  {
    id: "スポット管理",
    children: [
      {
        id: "下書き",
        path: "/spots",
        icon: <PushPin />,
        active: true
      },
      {
        id: "公開済み",
        path: "/spots/public",
        icon: <PushPin />,
        active: true
      }
    ]
  },
  {
    id: "ユーザー管理",
    children: [
      {
        id: "行動記録一覧",
        path: "/interactions",
        icon: <Person />,
        active: true
      }
    ]
  },
  {
    id: "デモ推薦",
    children: [
      {
        id: "推薦ロジック管理",
        path: "/recommendation/config",
        icon: <Hub />,
        active: true
      },
      {
        id: "推薦シミュレーション",
        path: "/recommendation_mockup",
        icon: <Hub />,
        active: true
      }
    ]
  },
  {
    id: "LINE設定",
    children: [
      {
        id: "LINE推薦ロジック管理",
        path: "/line/recommendation/config",
        icon: <Hub />,
        active: true
      },
      {
        id: "メッセージテンプレート管理",
        path: "/line/message_templates",
        icon: <Message />,
        active: true
      }
    ]
  },
  {
    id: "各種管理ジョブ",
    children: [
      {
        id: "Googleリスト取り込み",
        path: "/user_data_importer",
        icon: <Settings />,
        active: true
      },
      {
        id: "スポット登録リクエスト管理",
        path: "/user_requests",
        icon: <Settings />,
        active: true
      }
    ]
  },
  {
    id: "システム設定",
    children: [
      {
        id: "サインアップ設定",
        path: "/signup/config",
        icon: <Settings />,
        active: true
      }
    ]
  }
];

const item = {
  py: "2px",
  px: 3,
  color: "rgba(255, 255, 255, 0.7)",
  "&:hover, &:focus": {
    bgcolor: "rgba(255, 255, 255, 0.08)"
  }
};

const itemCategory = {
  boxShadow: "0 -1px 0 rgb(255,255,255,0.1) inset",
  py: 1.5,
  px: 3
};

export const Navigator = (props: DrawerProps) => {
  const { ...other } = props;

  const location = useLocation();
  const navigate = useNavigate();

  return (
    <Drawer variant="permanent" {...other}>
      <List disablePadding>
        <ListItem sx={{ ...item, ...itemCategory, fontSize: 22, color: "#fff" }}>
          <ListItemButton onClick={() => navigate("/")} sx={{ p: 0, m: 0 }} disableRipple>
            Refloop &nbsp;
            <Chip
              label={targetEnv}
              variant="outlined"
              size="small"
              sx={{ color: "#fff", borderColor: "#fff" }}
            />
          </ListItemButton>
        </ListItem>
        {categories.map(({ id, children }) => (
          <Box key={id} sx={{ bgcolor: "#101F33" }}>
            <ListItem sx={{ py: 2, px: 3 }}>
              <ListItemText sx={{ color: "rgba(255, 255, 255, 0.75)" }}>{id}</ListItemText>
            </ListItem>
            {children.map(({ id: childId, path, icon, active }) => (
              <ListItem disablePadding key={childId}>
                <ListItemButton
                  selected={location.pathname === path}
                  sx={item}
                  onClick={() => navigate(path)}
                >
                  <ListItemIcon>{icon}</ListItemIcon>
                  <ListItemText sx={{ "* span": { color: "#fff" } }}>{childId}</ListItemText>
                </ListItemButton>
              </ListItem>
            ))}
            <Divider sx={{ mt: 2 }} />
          </Box>
        ))}
      </List>
    </Drawer>
  );
};
